<template>
  <div>
    <breadCrumb
      :icon="'fa-store'"
      :category="$t(`sideNav.navSalonSetting`)"
      :subCategory="$t(`subMenu.salon_setting_outlet`)"
      :subSubCategory="''">
    </breadCrumb>
    <div class="p-1">
      <div class="panel mb-0">
        <div class="panel-hdr pt-3 pb3">
          <div class="d-flex justify-content-end w-100 mb-3">
            <!-- <div class="d-flex">
              <b-button class="mr-1" variant="primary">{{
                $t("nav.change_loyalty_password")
              }}</b-button>
            </div> -->
            <exportCSV
              class="link btn buttons-csv buttons-html5 btn-primary mr-2"
              :data="exportData"
              :fields="exportFields"
              :header="exportHeaders"
              type="csv"
              :escapeCsv="false"
              :name="exportFileName">
              <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
          </div>
        </div>
        <div class="panel-container">
          <div class="panel-content">
            <div
              v-if="isSpinnerShow"
              class="d-flex justify-content-center mt-3 mb-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div
              class="panel-tag mt-3"
              v-if="!isSpinnerShow && totalEntries == 0">
              {{ $t("table.no_records") }}
            </div>
            <div
              v-if="!isSpinnerShow && totalEntries != 0"
              class="dataTables_wrapper dt-bootstrap4">
              <div class="row justify-content-end mt-2">
                <div class="col-auto pt-2">
                  <span>{{
                    $t("table.pagination", {
                      startPage: startPage,
                      endPage: endPage,
                      totalEntries: totalEntries,
                    })
                  }}</span>
                </div>
                <div class="col-auto">
                  <b-pagination
                    class="ml-3"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalEntries"
                    @input="handlePagination"></b-pagination>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 overflow-auto">
                  <b-table
                    striped
                    hover
                    :fields="outletTblHeaders"
                    :items="outletLists"
                    responsive>
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                    <template #cell(index)="data">
                      {{ data.index + startPage }}
                    </template>
                    <template #cell(bizName)="data">
                      {{ data.item.bizName == "" ? "-" : data.item.bizName }}
                    </template>
                    <template #cell(location)="data">
                      {{ data.item.location }}
                    </template>
                    <template #cell(city)="data">
                      <div class="d-flex justify-content-between">
                        <!-- {{
                          data.item.map.city == "" ? "-" : data.item.map.city
                        }} -->
                        <span v-if="!data.item.editCity">{{
                          data.item.map.city == "" ? "-" : data.item.map.city
                        }}</span>
                        <span class="w-100 pr-2" v-if="data.item.editCity">
                          <multiselect
                            v-model="data.item.map"
                            label="city"
                            track-by="cityID"
                            :options="cityList"
                            :searchable="true"
                            :show-labels="false"
                            openDirection="below"
                            placeholder="Select city"
                            style="width:230px;"
                            @select="editCity($event, data.item.outletID)"
                            @input="data.item.editCity = false">
                            <template slot="option" slot-scope="{ option }">{{
                              option.city
                            }}</template>
                          </multiselect>
                        </span>
                        <a
                          style="z-index: 100"
                          v-show="!data.item.editCity"
                          class="link text-primary"
                          @click="data.item.editCity = true">
                          <b-icon variant="primary" icon="pencil"></b-icon>
                        </a>
                        <a
                          style="z-index: 100"
                          v-show="data.item.editCity"
                          class="link text-primary"
                          @click="data.item.editCity = false">
                          <b-icon variant="primary" icon="X"></b-icon>
                        </a>
                      </div>
                    </template>
                    <template #cell(username)="data">
                      <div class="d-flex justify-content-center flex-column">
                        <span>
                          {{
                            data.item.loyalty.username == ""
                            ? "-"
                            : data.item.loyalty.username
                          }}
                        </span>
                        <span>
                          {{
                            data.item.contact.telephone == ""
                            ? "-"
                            : data.item.contact.telephone
                          }}
                        </span>
                        <!-- <span v-if="!data.item.editName">{{data.item.loyalty.username == "" ? "-" : data.item.loyalty.username}}</span>
                                                <span v-if="data.item.editName"><input type="text" :value="data.item.loyalty.username" class="form-control"></span>
                                                <a style="z-index:100;" v-show="!data.item.editName" class="link text-primary" @click="data.item.editName = true">
                                                    <b-icon variant="primary" icon="pencil"></b-icon>
                                                </a>
                                                <a style="z-index:100;" v-show="data.item.editName" class="link text-primary" @click="data.item.editName = false">
                                                    <b-icon variant="primary" icon="X"></b-icon>
                                                </a> -->
                      </div>
                    </template>
                    <template #cell(isEnable)="data">
                      <!-- <span
                          v-if="data.item.emerchant.shortname != ''"
                          class="badge"
                          :class="
                            data.item.emerchant.shortname != ''
                              ? 'badge-primary'
                              : 'badge-secondary'
                          "
                          >{{
                            data.item.emerchant.shortname != ""
                              ? $t("table.value.enable")
                              : $t("table.value.disable")
                          }}</span
                        >
                        <a
                          class="badge badge-secondary buttonEnable"
                          v-if="data.item.emerchant.shortname == ''"
                          v-b-modal.enableEmerchantModal
                          @click="emerchantOutletID = data.item.outletID"
                          :title="'Enable Emerchant'"
                        >
                          Enable
                        </a> -->
                      <b-form-checkbox
                        :id="'enable-emerchant-' + data.item.outletID"
                        :disabled="data.item.emerchantEnabled"
                        v-model="data.item.emerchantEnabled"
                        @change="enableEmerchantModal(data.item.outletID)"
                        :title="'Emerchant'"
                        switch>
                        <label :for="'enable-emerchant-' + data.item.outletID">Emerchant</label>
                      </b-form-checkbox>
                      <b-form-checkbox
                        :id="'enable-leaderboard-' + data.item.outletID"
                        v-model="data.item.leaderboardEnabled"
                        @change="enableLeaderboard(data.item)"
                        :title="'Staff Leaderboard'"
                        switch>
                        <label :for="'enable-leaderboard-' + data.item.outletID">Staff Leaderboard</label>
                      </b-form-checkbox>
                      <b-form-checkbox
                        :id="'enable-performance-' + data.item.outletID"
                        v-model="data.item.performanceEnabled"
                        @change="enablePerformance(data.item)"
                        :title="'Staff Performance'"
                        switch>
                        <label :for="'enable-performance-' + data.item.outletID">Staff Performance</label>
                      </b-form-checkbox>
                    </template>
                    <template #cell(action)="data">
                      <div
                        v-if="data.item.emerchantEnabled !== ''"
                        class="d-flex flex-column w-100">
                        <b-button
                          pill
                          size="sm"
                          variant="outline-primary"
                          class="mb-1"
                          @click="editOutletModal(data.item)">
                          <b-icon icon="lock"></b-icon>
                          Change Details
                        </b-button>
                        <!-- <b-button
                          pill
                          size="sm"
                          variant="outline-success"
                          class="mb-1"
                          v-b-modal.wassengerModal
                          @click="ws.id = data.item.outletID"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-whatsapp"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                            />
                          </svg>
                          Whatsapp Messenger
                        </b-button>
                        <b-button
                          pill
                          size="sm"
                          variant="outline-secondary"
                          class="mb-1"
                          @click="
                            twillioEnable(data.item.outletID, data.item.bizName)
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            preserveAspectRatio="xMidYMid"
                            viewBox="0 0 256 256"
                          >
                            <g fill="#CF272D">
                              <path
                                d="M127.86 222.304c-52.005 0-94.164-42.159-94.164-94.163 0-52.005 42.159-94.163 94.164-94.163 52.004 0 94.162 42.158 94.162 94.163 0 52.004-42.158 94.163-94.162 94.163zm0-222.023C57.245.281 0 57.527 0 128.141 0 198.756 57.245 256 127.86 256c70.614 0 127.859-57.244 127.859-127.859 0-70.614-57.245-127.86-127.86-127.86z"
                              />
                              <path
                                d="M133.116 96.297c0-14.682 11.903-26.585 26.586-26.585 14.683 0 26.585 11.903 26.585 26.585 0 14.684-11.902 26.586-26.585 26.586-14.683 0-26.586-11.902-26.586-26.586M133.116 159.983c0-14.682 11.903-26.586 26.586-26.586 14.683 0 26.585 11.904 26.585 26.586 0 14.683-11.902 26.586-26.585 26.586-14.683 0-26.586-11.903-26.586-26.586M69.431 159.983c0-14.682 11.904-26.586 26.586-26.586 14.683 0 26.586 11.904 26.586 26.586 0 14.683-11.903 26.586-26.586 26.586-14.682 0-26.586-11.903-26.586-26.586M69.431 96.298c0-14.683 11.904-26.585 26.586-26.585 14.683 0 26.586 11.902 26.586 26.585 0 14.684-11.903 26.586-26.586 26.586-14.682 0-26.586-11.902-26.586-26.586"
                              />
                            </g>
                          </svg>
                          Twillio
                        </b-button> -->
                        <b-button
                          pill
                          size="sm"
                          variant="outline-danger"
                          class="mb-1"
                          @click="
                            manageOulet(data.item.outletID, data.item.username)
                            ">
                          <b-icon icon="backspace-reverse"></b-icon>
                          Force Logout
                        </b-button>
                      </div>
                    </template>
                    <!-- <template #cell(action)="data">
                      <button
                        class="btn btn-link text-primary"
                        style="font-size: 15px"
                        :disabled="data.item.emerchantEnabled == ''"
                        :title="$t('button_link.manage_outlet')"
                        @click="editOutletModal(data.item)"
                      >
                        <b-icon icon="lock"></b-icon>
                      </button>
                    </template>
                    <template #cell(action2)="data">
                      <button
                        class="btn btn-link text-primary"
                        style="font-size: 15px"
                        :disabled="data.item.emerchantEnabled == ''"
                        :title="$t('button_link.manage_outlet')"
                        @click="
                          manageOulet(data.item.outletID, data.item.username)
                        "
                      >
                        <b-icon icon="backspace-reverse"></b-icon>
                      </button>
                    </template>
                     <template #cell(action3)="data">
                      <button
                        class="btn btn-link text-primary"
                        style="font-size: 15px"
                        :disabled="data.item.emerchantEnabled == ''"
                        :title="$t('button_link.manage_outlet')"
                        v-b-modal.wassengerModal
                        @click="ws.id = data.item.outletID"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
</svg>
                      </button>
                    </template> -->
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ show: toggleModal }" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom">
            <h5 class="modal-title h4">
              {{ $t("button_link.manage_outlet") }}
              <small class="m-0 text-muted">{{ $t("button_link.force_logout") }} - "{{ sTitle }}"</small>
            </h5>
            <button type="button" class="close" @click="toggleModal = false">
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="
                modal-body-bg
                text-center
                w-100
                p-5
                bg-fusion-50 bg-primary-gradient
              ">
              <i class="fal fa-phone-laptop fa-9x"></i>
            </div>
            <button
              type="button"
              class="
                btn
                text-white
                fw-500
                border-0
                bg-primary-50 bg-primary-gradient
                btn-block
              "
              @click="forceLogout">
              {{ $t("button_link.force_logout") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal ref="modal" @performConfirmAction="performForceLogout"></modal>
    <b-modal size="lg" title="Edit" id="outletEditModal">
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-between" style="height: 50px">
            <h5>
              Change
              {{ passwordTab == "Loyalty" ? "TunaiLoyalty" : "Emerchant" }}
              Details
            </h5>
            <div>
              <b-button-group size="sm">
                <b-button
                  style="border-radius: 50rem 0 0 50rem"
                  variant="outline-primary"
                  :class="passwordTab == 'Loyalty' ? 'active' : ''"
                  @click="passwordTab = 'Loyalty'">Loyalty</b-button>
                <b-button
                  style="border-radius: 0 50rem 50rem 0"
                  variant="outline-primary"
                  :disabled="outletDetail.emerchantEnabled"
                  :class="passwordTab == 'Emerchant' ? 'active' : ''"
                  @click="passwordTab = 'Emerchant'">Emerchant</b-button>
              </b-button-group>
            </div>
          </div>
          <div class="d-flex flex-column">
            <label class="form-label">{{ $t("label.username") }}</label>
            <div class="input-group bg-white shadow-inset-2">
              <div class="input-group-prepend">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="fas fa-user"></i>
                </span>
              </div>
              <b-form-input
                id="userName"
                :state="userNameState"
                v-if="passwordTab == 'Loyalty'"
                class="form-control pl-3"
                v-maska
                data-maska="z"
                :disabled="passwordTab == 'Emerchant'"
                data-maska-tokens="z:[A-Z,a-z,0-9,.]:multiple"
                :placeholder="$t('label.username')"
                v-model="outletDetail.username"
                aria-describedby="userName-feedback"
                required></b-form-input>
              <b-form-input
                v-else-if="passwordTab == 'Emerchant'"
                id="userName"
                class="form-control pl-3"
                v-maska
                data-maska="z"
                :disabled="passwordTab == 'Emerchant'"
                data-maska-tokens="z:[A-Z,a-z,0-9,.]:multiple"
                :placeholder="$t('label.username')"
                v-model="outletUsername"
                aria-describedby="userName-feedback"
                required></b-form-input>
              <div class="input-group-append">
                <span class="input-group-text bg-transparent">@tunai</span>
              </div>
            </div>
          </div>
          <!-- <div class="d-flex mt-2 flex-column">
            <label>City</label>
            <multiselect
              v-model="outletDetail.city"
              label="city"
              track-by="cityID"
              :options="cityList"
              :searchable="true"
              :show-labels="false"
              openDirection="below"
              placeholder="Select city"
            >
              <template slot="option" slot-scope="{ option }">{{
                option.city
              }}</template>
            </multiselect>
          </div> -->
          <div class="d-flex flex-column mt-2">
            <div class="d-flex justify-content-between">
              <label class="required">Mobile</label>
            </div>
            <b-form-input
              v-model="outletDetail.mobile"
              v-maska
              data-maska="z"
              data-maska-tokens="z:[0-9]:multiple"
              :state="mobileState"></b-form-input>
            <span
              v-show="mobileState !== null && !mobileState"
              class="text-danger"
              id="mobile-feedback">
              Invalid Mobile
            </span>
          </div>
          <div class="d-lg-flex flex-md-column flex-lg-row">
            <div
              class="
                d-flex
                mt-2
                col-sm-12
                pr-lg-2
                pl-0
                col-md-12 col-lg-6
                flex-column">
              <label>New Password</label>
              <b-input-group>
                <b-form-input
                  :state="newPasswordState"
                  v-model="outletDetail.newPassword"
                  :type="showPassword ? 'text' : 'password'"></b-form-input>
                <template #append>
                  <button
                    @click="showPassword = !showPassword"
                    class="input-group-text btn-link">
                    <b-icon icon="eye" v-if="!showPassword"></b-icon>
                    <b-icon icon="eye-slash" v-else></b-icon>
                  </button>
                </template>
              </b-input-group>
            </div>
            <div
              class="
                d-flex
                mt-2
                col-sm-12 col-md-12
                px-0
                pr-0
                col-lg-6
                flex-column
              ">
              <label>Confirm Password</label>
              <b-input-group>
                <b-form-input
                  :state="confirmPasswordState"
                  v-model="outletDetail.confirmPassword"
                  :type="showPassword ? 'text' : 'password'"></b-form-input>
                <template #append>
                  <button
                    @click="showPassword = !showPassword"
                    class="input-group-text btn-link">
                    <b-icon icon="eye" v-if="!showPassword"></b-icon>
                    <b-icon icon="eye-slash" v-else></b-icon>
                  </button>
                </template>
              </b-input-group>
            </div>
          </div>
          <div
            class="card my-2 p-2 d-flex text-secondary"
            style="background-color: #fff9b6; font-size: 0.75em">
            At least 6 characters long & 1 UPPERCASE letter.<br />
          </div>
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              variant="primary"
              :disabled="(outletDetail.mobile != '' && !confirmPasswordState) ||
                confirmPasswordState == null
                "
              @click="editOutlet()">Save</b-button>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div></div>
      </template>
    </b-modal>
    <b-modal id="enableEmerchantModal" :title="'Enable Emerchant'" size="sm">
      <div class="d-flex flex-column">
        <label>Shortname</label>
        <input
          type="text"
          v-model="shortname"
          v-maska
          data-maska="z"
          data-maska-tokens="z:[A-Z,a-z,0-9,.]:multiple"
          class="form-control" />
      </div>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="enableEmerchant()"
            :disabled="shortname === ''">Enable</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="wassengerModal" title="Setup Whatsapp Messenger">
      <div class="d-flex flex-column">
        <label for="">Wassenger API Key</label>
        <b-form-input v-model="ws.string"></b-form-input>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <b-button
              variant="primary"
              @click="setupWassanger(ws.id, ws.string)">Save</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Modal from "./../Delete_Modal";
import BreadCrumb from "./../Bread_Crumb";
import { vMaska } from "maska";
import exp from "./../../../assets/js/dashboard/export-table-header";
import {
  handleSessionExpired,
  setReturnData,
} from "./../../../assets/js/dashboard/dashboard";
import Swal from "sweetalert2";
export default {
  name: "outlet",
  directives: { maska: vMaska },
  components: {
    Modal,
    BreadCrumb,
  },
  data() {
    return {
      isSpinnerShow: false,
      outletID: 0,
      outletLists: [],
      toggleModal: false,
      sTitle: "",
      forceLogoutToggle: false,
      ws: {
        id: 0,
        string: "",
      },
      outletDetail: {
        id: 0,
        username: "",
        city: null,
        newPassword: "",
        mobile: "",
        currentPassword: "",
        confirmPassword: "",
        emerchantEnabled: false,
      },
      cityList: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      exportHeaders: [],
      exportData: [],
      exportFileName: "",
      passwordTab: "Loyalty",
      checkedPasswordChange: false,
      shortname: "",
      emerchantOutletID: 0,
      userNameState: null,
      confirmPasswordState: null,
      newPasswordState: null,
      currentPasswordState: null,
      mobileState: null,
      showPassword: false,
      outletUsername: ""
    };
  },
  computed: {
    confirmPassValidation() {
      return false;
    },
    outletTblHeaders() {
      return [
        { key: "selected", label: "", thClass: "thead-themed align-middle" },
        { key: "index", label: "#", thClass: "thead-themed align-middle" },
        {
          key: "bizName",
          label: this.$i18n.t("table.header.bizName"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "location",
          label: this.$i18n.t("table.header.location"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "city",
          label: this.$i18n.t("table.header.city"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "username",
          label: this.$i18n.t("table.header.username"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "isEnable",
          label: "Enable",
          thClass: "thead-themed",
        },
        {
          key: "action",
          label: "",
          thClass: "thead-themed align-middle",
          tdClass: "text-center",
        },
        //         {
        //   key: "action2",
        //   label: "",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "text-center",
        // },
        // {
        //   key: "action3",
        //   label: "",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "text-center",
        // },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.bizName")] = "bizName";
      ret[this.$i18n.t("table.header.location")] = "location";
      ret[this.$i18n.t("table.header.city")] = "city";
      ret[this.$i18n.t("table.header.username")] = "userName";
      ret[this.$i18n.t("table.header.contact")] = "contact";
      ret[this.$i18n.t("table.header.enable")] = "isEnable";

      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.getExportData();
    },
    "outletDetail.username": function (newVal) {
      let findItem = this.outletLists.find(
        (i) =>
          this.outletDetail.id !== i.outletID &&
          i.emerchant.username.replace("@tunai", "") === newVal
      );
      if (findItem !== undefined) {
        this.userNameState = false;
      } else {
        this.userNameState = true;
      }
    },
    "outletDetail.newPassword"(val) {
      if (val == "" || val === null || val === undefined) {
        this.newPasswordState = null;
        return;
      }
      if (val.length < 6) {
        this.newPasswordState = false;
        return;
      }
      let flag = false;
      for (let x = 0; x < val.length; x++) {
        if (
          val[x].toUpperCase() === val[x] &&
          val[x] !== val[x].toLowerCase()
        ) {
          flag = true;
        }
      }
      if (!flag) {
        this.newPasswordState = false;
        return;
      } else {
        this.newPasswordState = true;
        return;
      }
    },
    "outletDetail.confirmPassword"(val) {
      if (val == "") {
        this.confirmPasswordState = null;
        return;
      }
      if (val === this.outletDetail.newPassword) {
        this.confirmPasswordState = true;
        return;
      } else {
        this.confirmPasswordState = false;
        return;
      }
    },
  },
  methods: {
    async twillioEnable(id, bizName) {
      let flag = false;
      await Swal.fire({
        title: `Enable twiollio for outlet ${bizName}`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let url = "";
      let $vm = this;
      let result = [];
      url = "/" + id + this.$api.TWILLIO;

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status === 200) {
        this.toastrExe("Twillio", "Twillio activated", "success");
        this.$bvModal.hide("wassengerModal");
      } else {
        this.toastrExe("Twillio", "Error", "danger");
      }
    },
    async setupWassanger(id, ws) {
      let url = "";
      let $vm = this;
      let result = [];
      url = "/" + id + this.$api.WASSENGER;

      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            wassenger: ws,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status === 200) {
        this.toastrExe(
          "Whatsapp Messenger",
          "Whatsapp Messenger Account successfully activated",
          "success"
        );
        this.$bvModal.hide("wassengerModal");
      } else {
        this.toastrExe("Whatsapp Messenger", "Error", "danger");
      }
    },
    editCity(event, id) {
      console.log(event);
      let url = "";
      let $vm = this;
      let result = [];
      url = "/" + id + "/cityID";

      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            cityID: event.cityID,
          },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      event.editCity = false;
      this.toastrExe(
        "Edit Outlet City",
        `Outlet ID: ${id} city has been changed to ${event.city}`,
        "success"
      );
    },
    async editOutlet() {
      let $vm = this;
      let url = "";
      let result = [];
      if (this.passwordTab == "Loyalty")
        url = "/" + this.outletDetail.id + "/password";
      else url = "/" + this.outletDetail.id + "/emerchant/password";
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            password: this.outletDetail.newPassword,
            mobile: this.outletDetail.mobile,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status === 200) {
        this.mobileState = true;
      } else {
        this.mobileState = false;
        return;
      }
      if (this.passwordTab == "Loyalty") {
        url = "/" + this.outletDetail.id + "/username";

        await $vm
          .$axios({
            method: "post",
            url: url,
            baseURL: $vm.$api.BEBUSINESS_OUTLET,
            headers: { token: $vm.$session.get("token") },
            data: {
              username: this.outletDetail.username,
            },
          })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result = err.response;
            var errData = err.response.data;
            if (errData.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });
      }

      if (result.status === 200) {
        this.$bvModal.hide("outletEditModal");
        this.toastrExe(
          "Edit Outlet",
          `Outlet ID:${this.outletDetail.id} successfully edited.`,
          "success"
        );
        this.getOutlets();
        this.clearForm();
      } else {
        this.toastrExe("Edit Outlet", `Error.`, "danger");
      }
    },
    clearForm() {
      this.outletDetail = {
        id: 0,
        username: "",
        city: null,
        newPassword: "",
        mobile: "",
        currentPassword: "",
        confirmPassword: "",
        emerchantEnabled: false,
      };
      this.userNameState = null;
      this.confirmPasswordState = null;
      this.newPasswordState = null;
      this.currentPasswordState = null;
      this.mobileState = null;
    },
    async enableEmerchant() {
      let $vm = this;
      let url = "";
      let result = [];
      url = `/${this.emerchantOutletID}/emerchant/enable`;
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            shortname: this.shortname,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.shortname = "";
      if (result != null) {
        this.$bvModal.hide("enableEmerchantModal");
        this.toastrExe(
          "Enable E-merchant",
          `E-merchant for outlet ID:${this.emerchantOutletID} successfully enabled.`,
          "success"
        );
        this.getOutlets();
      } else {
        this.$bvModal.hide("enableEmerchantModal");
        this.toastrExe("Enable", "Error.", "danger");
      }
    },
    enableEmerchantModal(outletID) {
      this.emerchantOutletID = outletID;
      this.$bvModal.show("enableEmerchantModal");
    },
    async enableLeaderboard(outlet) {
      let $vm = this;
      let url = "";
      let result = [];
      url = `https://bebusiness.tunai.io/outlet/${outlet.outletID}/staffapp`;
      await $vm
        .$axios({
          method: "post",
          url: url,
          // baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            leaderBoardTypeID: outlet.leaderboardEnabled ? 1 : 0,
            performanceTypeID: outlet.performanceEnabled ? 1 : 0,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result != null) {
        this.toastrExe(
          (outlet.leaderboardEnabled ? 'Enable' : 'Disable') + " Staff Leaderboard",
          `Staff leaderboard for outlet:${(outlet.emerchant || {}).username || outlet.outletID} successfully ${(outlet.leaderboardEnabled ? 'enabled' : 'disabled')}.`,
          "success"
        );
        this.getOutlets();
      } else {
        this.toastrExe("Enable", "Error.", "danger");
      }
    },
    async enablePerformance(outlet) {
      console.log(outlet)
      let $vm = this;
      let url = "";
      let result = [];
      url = `https://bebusiness.tunai.io/outlet/${outlet.outletID}/staffapp`;
      await $vm
        .$axios({
          method: "post",
          url: url,
          // baseURL: $vm.$api.BEBUSINESS_OUTLET,
          headers: { token: $vm.$session.get("token") },
          data: {
            leaderBoardTypeID: outlet.leaderboardEnabled ? 1 : 0,
            performanceTypeID: outlet.performanceEnabled ? 1 : 0,
          },
        })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result != null) {
        this.toastrExe(
          (outlet.performanceEnabled ? 'Enable' : 'Disable') + " Staff Performance",
          `Staff performance for outlet:${(outlet.emerchant || {}).username || outlet.outletID} successfully ${(outlet.performanceEnabled ? 'enabled' : 'disabled')}.`,
          "success"
        );
        this.getOutlets();
      } else {
        this.toastrExe("Enable", "Error.", "danger");
      }
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    async editOutletModal(data) {
      this.outletDetail.id = data.outletID;
      this.outletUsername = data.loyalty.username.replace("@tunai", "");
      this.outletDetail.username = data.loyalty.username.replace("@tunai", "");
      this.outletDetail.emerchantEnabled = data.emerchant.shortname === "";
      this.cityList = await this.getCityList();

      this.outletDetail.city = this.cityList.find(
        (c) => c.cityID == data.map.cityID
      );
      this.$bvModal.show("outletEditModal");
    },
    closeModal(isError) {
      if (!isError) {
        this.toggleModal = false;
        this.$refs.modal.toggleModal = false;
        this.getOutlets();
      }
      this.$parent.isModalShow = false;
    },
    handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        this.getOutlets();
      }
    },
    async getExportData() {
      let $vm = this;
      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: $vm.$api.OUTLET,
          baseURL: this.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.outlets;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.setExportData(result);
    },
    setExportData(data) {
      this.exportData = [];
      let header =
        this.$msg.REPORT.HEADER + this.$i18n.t("subMenu.salon_setting_outlet");
      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
        moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];
      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          bizName: data[i].bizName == "" ? "-" : data[i].bizName,
          location: "" + data[i].location,
          city: data[i].city == "" ? "-" : data[i].city,
          userName: data[i].username,
          contact: data[i].mobile,
          isEnable:
            data[i].isEnable == 1
              ? this.$i18n.t("table.value.enable")
              : this.$i18n.t("table.value.disable"),
        });
      }
    },
    async getCityList() {
      let $vm = this;
      const url = $vm.$api.INFO + $vm.$api.CITY;

      var city = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          city = response.data.result;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return city;
    },
    async getOutlets() {
      let $vm = this;
      $vm.isSpinnerShow = true;
      const url = $vm.$api.BEBUSINESS_OUTLET;
      $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          // let list = response.data;
          // list.forEach((element) => {
          //   element.emerchantEnabled = element.emerchant.shortname !== "";
          //   element.location =
          //     element.map.location == "" ? "-" : element.map.location;
          //   element.editCity = false;
          // });
          // var retData = setReturnData(list, response.data.length, $vm.page);
          // $vm.outletLists = retData.result;
          // $vm.totalEntries = retData.result.length;
          // $vm.totalPage = retData.totalPage;

          // $vm.startPage = retData.startPage;
          // $vm.endPage = retData.endPage;
          // $vm.isSpinnerShow = false;
          this.loadLeaderboard(response.data)
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      await this.getExportData();
    },
    async loadLeaderboard(outlets) {
      let $vm = this;

      for (let outlet of outlets) {
        await $vm
          .$axios({
            method: "get",
            url: `https://bebusiness.tunai.io/outlet/${outlet.outletID}/staffapp`,
            headers: { token: $vm.$session.get("token") },
          })
          .then(function (response) {
            if (response.data && response.data[0]) {
              outlet['leaderboardEnabled'] = response.data[0]['leaderBoardTypeID'] ? true : false
              outlet['performanceEnabled'] = response.data[0]['performanceTypeID'] ? true : false
            }
          })
          .catch((err) => {
            var errData = err.response.data;
            if (errData.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });

        outlet.emerchantEnabled = outlet.emerchant.shortname !== "";
        outlet.location = outlet.map.location == "" ? "-" : outlet.map.location;
        outlet.editCity = false;
      }

      this.isSpinnerShow = false;
      let list = outlets;
      outlets.forEach((element) => {
      });
      var retData = setReturnData(list, outlets.length, $vm.page);
      $vm.outletLists = retData.result;
      $vm.totalEntries = retData.result.length;
      $vm.totalPage = retData.totalPage;

      $vm.startPage = retData.startPage;
      $vm.endPage = retData.endPage;
      $vm.isSpinnerShow = false;
    },
    manageOulet(id, title) {
      this.outletID = id;
      this.sTitle = title;
      this.toggleModal = true;
    },
    forceLogout() {
      var title = this.$i18n.t("button_link.force_logout");
      var message = this.$i18n.t("message.confirmation.force_logout", {
        user: this.sTitle,
      });
      this.$refs.modal.showModal(title, message);
    },
    performForceLogout() {
      let $vm = this;
      const url = $vm.$api.OUTLET + "/" + $vm.outletID + $vm.$api.LOGOUT;
      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          if (response.status == 200) {
            $vm.forceLogoutToggle = false;
            var message = $vm.$i18n.t("message.success.logout", {
              user: $vm.sTitle,
            });
            $vm.$parent.setModal($vm, false, true, message);
          }
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
  },
  async mounted() {
    let $vm = this;
    $vm.getOutlets();
    this.cityList = await this.getCityList();
  },
};
</script>
<style scoped>
.show {
  display: block;
}

.modal-body-bg {
  opacity: 0.1;
}

@keyframes glowing {
  0% {
    background-color: rgb(210, 210, 210);
    box-shadow: 0 0 2px rgb(210, 210, 210);
    border-radius: 4px;
    color: black;
  }

  50% {
    background-color: rgb(175, 175, 175);
    box-shadow: 0 0 10px rgb(175, 175, 175);
    border-radius: 4px;
    color: white;
  }

  100% {
    background-color: rgb(201, 200, 200);
    box-shadow: 0 0 5px rgb(201, 200, 200);
    border-radius: 4px;
    color: black;
  }
}

.buttonEnable {
  animation: glowing 1300ms infinite;
}

.buttonEnable:hover {
  animation: none;
  color: white;
}

.custom-control-input[disabled] {
  color: black !important;
}
</style>
